import { INSTRUCTION_CONTENT_MAX_LENGTH } from '@/components/constants';
import { InstructionPdfForm } from '@/features/ap_payees/components/DocInstructionMenu/types';
import { useTranslation } from '@/i18n';
import { FormTextArea, Label } from '@moneyforward/ap-frontend-components';
import { FC, useMemo } from 'react';
import { Control } from 'react-hook-form';
import styles from '../styles.module.scss';
import { validationRules } from '@/features/ap_payees/components/DocInstructionMenu/Helpers/validationRules';

export type TInstructionContentProps = {
  control: Control<InstructionPdfForm>;
};

export const InstructionContent: FC<TInstructionContentProps> = ({
  control,
}) => {
  const { t } = useTranslation();
  const contentRules = useMemo(
    () => ({
      required: {
        value: true,
        message: t('common.validation.required'),
      },
      validate: validationRules.requiredNotAllowEmpty(
        t('common.validation.required')
      ),
      maxLength: {
        value: INSTRUCTION_CONTENT_MAX_LENGTH,
        message: t('common.validation.max_length', {
          maxLength: INSTRUCTION_CONTENT_MAX_LENGTH,
        }),
      },
    }),
    [t]
  );

  const contentProps = useMemo(
    () => ({
      style: {
        height: 'calc(100vh - 478px)',
        minHeight: '150px',
      },
    }),
    []
  );
  return (
    <div className={styles.row}>
      <div className={styles.label}>
        <Label
          text={t('export_instruction_pdf_content')}
          htmlFor='content'
          tooltip={t('export_instruction_pdf_content_tooltip')}
        />
      </div>
      <div className={styles.content}>
        <FormTextArea<InstructionPdfForm>
          name='content'
          control={control}
          inputId='content'
          textAreaProps={contentProps}
          rules={contentRules}
        />
      </div>
    </div>
  );
};

InstructionContent.displayName = 'InstructionContent';
